import { render, staticRenderFns } from "./EdenServices.vue?vue&type=template&id=20060ada"
import script from "./EdenServices.vue?vue&type=script&lang=js"
export * from "./EdenServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports